import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "footnotenumberingstyle"
    }}>{`FootnoteNumberingStyle`}</h1>
    <p>{`Footnote numbering style options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UPPER_ROMAN`}</strong>{` = 1297247605`}</p>
      <p parentName="blockquote">{`Uses uppercase Roman numerals.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LOWER_ROMAN`}</strong>{` = 1297247596`}</p>
      <p parentName="blockquote">{`Uses lowercase Roman numerals.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UPPER_LETTERS`}</strong>{` = 1296855669`}</p>
      <p parentName="blockquote">{`Uses uppercase letters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LOWER_LETTERS`}</strong>{` = 1296855660`}</p>
      <p parentName="blockquote">{`Uses lowercase letters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC`}</strong>{` = 1298231906`}</p>
      <p parentName="blockquote">{`Uses Arabic numerals.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SYMBOLS`}</strong>{` = 1181971321`}</p>
      <p parentName="blockquote">{`Uses symbols.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KANJI`}</strong>{` = 1296788073`}</p>
      <p parentName="blockquote">{`Kanji.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_WIDTH_ARABIC`}</strong>{` = 1296455521`}</p>
      <p parentName="blockquote">{`Full-width Arabic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SINGLE_LEADING_ZEROS`}</strong>{` = 1297312890`}</p>
      <p parentName="blockquote">{`Single leading zeros.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOUBLE_LEADING_ZEROS`}</strong>{` = 1296329850`}</p>
      <p parentName="blockquote">{`Double leading zeros.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ASTERISKS`}</strong>{` = 1298232180`}</p>
      <p parentName="blockquote">{`Asterisks.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_ALIF_BA_TAH`}</strong>{` = 1296130420`}</p>
      <p parentName="blockquote">{`Uses Arabic Alif Ba Tah`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_ABJAD`}</strong>{` = 1296130410`}</p>
      <p parentName="blockquote">{`Uses Arabic Abjad`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEBREW_BIBLICAL`}</strong>{` = 1296589410`}</p>
      <p parentName="blockquote">{`Uses Hebrew Biblical`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEBREW_NON_STANDARD`}</strong>{` = 1296589422`}</p>
      <p parentName="blockquote">{`Uses Hebrew Non Standard`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      